import { doApi } from './apiClient';
import type {
  GetMyNotificationsResponse,
  MarkAsReadResponse,
  DeleteNotificationResponse,
} from '../types';

const BASE = 'api/notifications/v2';

/** GET /api/notifications/v2/my - tutte le notifiche dell'utente loggato */
export const apiGetMyNotifications = async (): Promise<GetMyNotificationsResponse> => {
  return doApi<GetMyNotificationsResponse>(`${BASE}/my`, 'GET');
};

/** GET /api/notifications/v2/my/unread - solo notifiche non lette */
export const apiGetMyUnreadNotifications = async (): Promise<GetMyNotificationsResponse> => {
  return doApi<GetMyNotificationsResponse>(`${BASE}/my/unread`, 'GET');
};

/** PATCH /api/notifications/v2/{id}/read - segna come letta */
export const apiMarkNotificationAsRead = async (id: number): Promise<MarkAsReadResponse> => {
  return doApi<MarkAsReadResponse>(`${BASE}/${id}/read`, 'PATCH');
};

/** DELETE /api/notifications/v2/{id} - elimina notifica (soft delete) */
export const apiDeleteNotification = async (id: number): Promise<DeleteNotificationResponse> => {
  return doApi<DeleteNotificationResponse>(`${BASE}/${id}`, 'DELETE');
};
